var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import showToast from "../../services/toast";
import { useBilling } from "./hook/billing.hook";
import { BillingView } from "./view/billing.view";
var GenerateBilling = function () {
    var billing = useBilling();
    return (_jsxs(_Fragment, { children: [billing.toast.show &&
                showToast(position.topRight, billing.toast.type === "error" ? typeAlert.error : typeAlert.success, billing.toast.message, function () { return billing.closeToast(); }), _jsx(LoadingAFY, { loading: billing.loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), billing.dataLoaded && _jsx(BillingView, __assign({}, billing))] }));
};
export default GenerateBilling;
